<template>
  <layout>
    <rdkm-title>
      {{ $t('Пациенты') }}
      <template v-if="$auth.user().isTc">
        <user-accessible routerName="PatientEdit">
        <router-link tag="span" to="/patients/add">
          <b-button class="float-right" right size="sm" variant="primary">
            <font-awesome-icon icon="plus" /> {{ $t('Новый пациент') }}
          </b-button>
        </router-link>
      </user-accessible>
      <user-accessible routerName="RelativePatients">
        <router-link tag="span" to="/patients/add/relative">
          <b-button class="float-right add-relative-patient" right size="sm" variant="secondary">
            <font-awesome-icon icon="plus" /> {{ $t('Семейное обследование') }}
          </b-button>
        </router-link>
      </user-accessible>
      </template>
    </rdkm-title>
    <div class="tile">
      <filter-form
        :lastName="filterQuery.lastName"
        :birthday="filterQuery.birthday"
        :createDateFrom="filterQuery.createDateFrom"
        :createDateTo="filterQuery.createDateTo"
        :updateDateFrom="filterQuery.updateDateFrom"
        :updateDateTo="filterQuery.updateDateTo"
        :description="filterQuery.description"
        :donorId="filterQuery.donorId"
        :authorId="filterQuery.authorId"
        :isRelatives="filterQuery.isRelatives"
        :modificationDate="filterQuery.modificationDate"
        :patientNumber="filterQuery.patientNumber"
        :operatorId="filterQuery.operatorId"
        :tcOrganizationId="filterQuery.tcOrganizationId"
        :statuses="filterQuery.statuses"
        v-on:search="$refs.grid.filter($event, true)"
      >
      </filter-form>
      <rdkm-grid
        v-if="$auth.user().isRdkm"
        ref="grid"
        :state="filterQuery"
        :defaultSortColumn="'createDate'"
      >
        <grid-column name="idp" :title="$t('IDP')" width="90" cell="edit-cell"></grid-column>
        <grid-column name="priority" v-if="canSetPriority" :title="$t('Приоритет')" width="100"></grid-column>
        <grid-column name="name" :title="$t('ФИО')"></grid-column>
        <grid-column width="120" :className="(row) => ( row.isTimeoutExpired ? 'red' : '')" name="timeout" :title="$t('Тайм-аут')" :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"></grid-column>
        <grid-column
          name="birthday"
          width="120"
          :title="$t('Дата рожд.')"
          :format="date => moment(date).format('DD.MM.YYYY')"
        ></grid-column>
        <grid-column name="status" width="150" :title="$t('Статус')"></grid-column>
        <grid-column name="coordinatorNotes" v-if="canSetPriority" :title="$t('Заметки')"></grid-column>
        <grid-column
          name="createDate"
          width="120"
          :title="$t('Дата созд.')"          
          :format="date => moment(date).format('DD.MM.YYYY')"
        ></grid-column>
        <grid-column name="tcCode" width="100" :title="$t('Код ТЦ')"></grid-column>
        <grid-column name="operatorName" :title="$t('Координатор Центра')"></grid-column>
      </rdkm-grid>
      <rdkm-grid
        v-else
        ref="grid"
        :state="query"
        :defaultSortColumn="'createDate'"
      >
        <grid-column name="idp" :title="$t('IDP')" width="85" cell="edit-cell"></grid-column>
        <grid-column name="priority" v-if="canSetPriority" :title="$t('Приоритет')" width="100"></grid-column>
        <grid-column
          v-if="$auth.user().isRdkm"
          name="operatorName"
          :title="$t('Координатор Центра')"
        ></grid-column>
        <grid-column name="name" :title="$t('ФИО')"></grid-column>
        <grid-column width="120" :className="(row) => ( row.isTimeoutExpired ? 'red' : '')" name="timeout" :title="$t('Тайм-аут')" :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"></grid-column>
        <grid-column
          name="birthday"
          :title="$t('Дата рожд.')"
          width="120"
          :format="date => moment(date).format('DD.MM.YYYY')"
        ></grid-column>
        <grid-column name="diagnosis" :title="$t('Диагноз')"></grid-column>
        <grid-column name="status" width="150" :title="$t('Статус')"></grid-column>
        <grid-column name="coordinatorNotes" v-if="canSetPriority" :title="$t('Заметки')"></grid-column>
        <grid-column
          name="createDate"
          :title="$t('Дата созд.')"
          width="120"
          :format="date => moment(date).format('DD.MM.YYYY')"
        ></grid-column>
        <grid-column name="operatorName" :title="$t('Координатор Центра')"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import FilterForm from './Filter.vue';
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';
import { mapGetters } from 'vuex';

export default {
  props: ['query'],
  components: {
    'filter-form': FilterForm,
    'rdkm-grid': Grid,
    'grid-column': GridColumn,
  },
  computed: {
    canSetPriority: function() {
      return (
          this.$auth.user().functions.find(t => t.routeName === "SetPatientPriority") != null
      );
    },
  },
  data() {
    return {
      filterQuery: {},
    };
  },
  beforeMount() {
    this.filterQuery = Object.assign({}, this.query);
    if (this.$auth.user().isTc) {
      this.filterQuery.tcOrganizationId = this.$auth.user().currentOrganization.id;
    } else if (this.$auth.user().isRdkm) {
      this.filterQuery.operatorId = this.$auth.user().id;
    } 
    //TODO подумать как убрать это отсюда. Костыль нужен чтобы на сервер шел 1 запрос на список пациентов а не 3-4 подряд.
    this.filterQuery.lastName = this.filterQuery.lastName ? this.filterQuery.lastName : '';
    this.filterQuery.birthday = this.filterQuery.birthday ? this.filterQuery.birthday : '';
    this.filterQuery.createDateFrom = this.filterQuery.createDateFrom ? this.filterQuery.createDateFrom : '';
    this.filterQuery.createDateTo = this.filterQuery.createDateTo ? this.filterQuery.createDateTo : '';
    this.filterQuery.updateDateFrom = this.filterQuery.updateDateFrom ? this.filterQuery.updateDateFrom : '';
    this.filterQuery.updateDateTo = this.filterQuery.updateDateTo ? this.filterQuery.updateDateTo : '';
    this.filterQuery.description = this.filterQuery.description ? this.filterQuery.description : '';
    this.filterQuery.donorId = this.filterQuery.donorId ? this.filterQuery.donorId : '';
    this.filterQuery.authorId = this.filterQuery.authorId ? this.filterQuery.authorId : '';
    this.filterQuery.modificationDate = this.filterQuery.modificationDate ? this.filterQuery.modificationDate : '';
    this.filterQuery.patientNumber = this.filterQuery.patientNumber ? this.filterQuery.patientNumber : '';
    this.filterQuery.operatorId = this.filterQuery.operatorId ? this.filterQuery.operatorId : '';
    this.filterQuery.tcOrganizationId = this.filterQuery.tcOrganizationId ? this.filterQuery.tcOrganizationId : '';
    this.filterQuery.isRelatives = this.filterQuery.isRelatives ? this.filterQuery.isRelatives : '';
  },
};
</script>
